export const formatDateToShortString = (dateString) => {
  const date = new Date(dateString);
  const shortMonth = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  return `${shortMonth} ${date.getDate()} ${date.getFullYear()}`;
};

export const formatTimeFromISO = (isoString: string) => {
  const date = new Date(isoString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const getDurationInMinutes = (startISO: string, endISO: string): number => {
  const diffInMs = new Date(endISO).getTime() - new Date(startISO).getTime();
  return Math.round(diffInMs / 60000);
};

export const groupByMonthYear = (data: any) => {
  const groups = {};

  data.forEach(item => {
    const dateObj = new Date(item.date);

    const monthYear = dateObj.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
    });

    if (!groups[monthYear]) {
      groups[monthYear] = [];
    }
    groups[monthYear].push(item);
  });

  return Object.entries(groups).map(([date, values]) => ({ date, values }));
};

export const capitalize = (str: string) => {
  return str[0].toUpperCase() + str.slice(1);
};

export const formatTitle = (title: string) => {
  if (!title) { return "Custom"; }
  if (title?.length > 25) {
    return title.slice(0, 25) + "...";
  }
  return title;
};

export const isShowingTooltip = (title: string) => {
  if (!title) { return false; }
  return title.length > 25;
};
